<template>
    <v-card flat>
        <v-data-table :headers="dTable.headers" :items="dMatConsejerias" :loading="dTable.loading" class="elevation-1 zebra-table">
            <template v-slot:no-data><v-alert :value="true" outlined type="warning" text border="left"><strong>No hay registros para mostrar.</strong></v-alert></template>
            <template v-slot:[`item.Estado`]="{ item }">
                <v-icon v-if="item.Estado=='FINALIZADO'" color="success" title="FINALIZADO">check_circle</v-icon>
                <v-icon v-else color="warning" title="EN PROCESO">watch_later</v-icon>
            </template>
            <template v-slot:[`item.Fecha`]="{ item }">
                {{item.Fecha.substring(0, 16)}}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                    </template>
                    <v-list>
                        <v-list-item>
                            <v-list-item-title><v-btn @click="fuModalEdit(item)" color="warning" block><v-icon>edit</v-icon> Editar</v-btn></v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="item.Estado=='EN PROCESO'">
                            <v-list-item-title><v-btn @click="fuModalFinalizar(item)" color="success" block><v-icon>check</v-icon> Finalizar</v-btn></v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title><v-btn @click="fuModalEliminar(item)" color="error" block dark><v-icon>delete</v-icon> Eliminar</v-btn></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-data-table>
        <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
            <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
        </v-snackbar>
    </v-card>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState, mapActions} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    name: 'CMatConsejeria',
    props: ['pIdAlumno'],
    mounted(){
    	this.fuLoad(this.pIdAlumno);
    },
    watch: {
        pIdAlumno(val){
            if(val)
                this.fuLoad(val);
        },
    },
    data: () => ({
        dSnackbar: false,
        dMatConsejeria: {
    		Detalle: '',
			Consejero: '',
			Fecha: '',
			Categoria: '',
			IdMatricula: null,
			IdAlumno: null,
			Tipo: 'Tutoria',
			IdPersonal: null,
			IdCategoria: null,
			IdSubCategoria: '1',
			IdEstadoSeguimiento: '1',
			FechaProgramado: '',
			Estado: 'FINALIZADO',
			Procedimiento: '',
    	},
        dMatConsejerias: [],
    	dMatConsejeriaCategoria: [],
        dMatConsejeriaSubCategoria: [],
        dMatConsejeriaEstadoSeguimiento: [],
        dModal: {
            dialog: false,
            editedIndex: -1,
            IsUpdating: false,
        },
    	dTable: {
            headers: [
                {value: 'actions', text: '...', sortable: false},
                {value: 'Categoria', text: 'Categoria'},
                {value: 'Detalle', text: 'Situacion del Alumno'},
                {value: 'Procedimiento', text: 'Accion del Tutor'},
                {value: 'Consejero', text: 'Consejero'},
                {value: 'Fecha', text: 'Fecha'},
                {value: 'FechaProgramado', text: 'Fecha Programado'},
                {value: 'Estado', text: 'Estado'},
            ],
            loading: false,
        }
    }),
    computed: {
        ...mapState(['ssUser']),
    },
    methods: {
        ...mapActions(['saMatConsejerias']),
    	async fuLoad(vIdAlumno){
            this.dTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query load($IdAlumno: ID!){
                        matconsejeriacategoria{
                            IdCategoria
                            Categoria
                        }
                        matconsejeriasubcategoria{
                            IdSubCategoria
                            SubCategoria
                        }
                        matconsejeriaestadoseguimiento{
                            IdEstadoSeguimiento
                            EstadoSeguimiento
                        }
                        matmatriculaLast(IdAlumno:$IdAlumno){
                            IdMatricula
                        }
                        matconsejeriaByIdAlumno(IdAlumno:$IdAlumno){
                            IdConsejeria
                            Detalle
                            Consejero
                            Fecha
                            Categoria
                            IdMatricula
                            IdAlumno
                            Tipo
                            IdPersonal
                            IdCategoria
                            IdSubCategoria
                            IdEstadoSeguimiento
                            FechaProgramado
                            conTicket
                            Estado
                            Procedimiento
                        }
                    }`,
                    variables: {
                        IdAlumno: vIdAlumno
                    }
                })
                this.dMatConsejeriaCategoria = response.data.matconsejeriacategoria.sort((a, b) => a.Categoria.localeCompare(b.Categoria));
                this.dMatConsejeriaSubCategoria = response.data.matconsejeriasubcategoria.sort((a, b) => a.SubCategoria.localeCompare(b.SubCategoria));
                this.dMatConsejeriaEstadoSeguimiento = response.data.matconsejeriaestadoseguimiento.sort((a, b) => a.EstadoSeguimiento.localeCompare(b.EstadoSeguimiento));

                if(this.matmatriculaLast){
                    this.dMatConsejeria.IdMatricula = response.data.matmatriculaLast[0].IdMatricula;
                    this.dMatConsejeriaDefault.IdMatricula = response.data.matmatriculaLast[0].IdMatricula;
                }

                this.dMatConsejerias = response.data.matconsejeriaByIdAlumno.sort((b, a) => a.Fecha.localeCompare(b.Fecha));
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Problema de Conexión.', 'error');
            } finally {
                this.dTable.loading = false
            }
        }
    },
}
</script>
